module.exports = __webpack_public_path__ + "img/bg-datacenter.7dba76d.png";